import axios from '@/lib/AxApi';

export default {
  selectRow(params, cb)
  {
    axios.get('/rest/User_companies/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getCompanyData(params, cb)
  {
    axios.get('/rest/User_companies/getCompanyData',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveCompanyData(params, cb)
  {
    axios.post('/rest/User_companies/updateRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/companydata.js